// extracted by mini-css-extract-plugin
export default {"input":"style_input__ccpvi","error":"style_error__mWObD"};